<template>
  <div class="swiper-fullscreen">
    <swiper :is-pagination="false" :height="'100%'" :loop="false" :autoplay="5000" ref="wechatSwiper">
      <swiper-item>
        <div class="cover-wrapper" style="height:100%;background-image:url('/static/img/wechat-1.png')">
          <img src="/static/img/wechat-1.png" />
        </div>
      </swiper-item>
      <swiper-item>
        <div class="cover-wrapper" style="height:100%;background-image:url('/static/img/wechat-2.png')">
          <img src="/static/img/wechat-2.png">
        </div>
        <div class="anim-container">
          <div class="back"><img src="/static/img/wechat-anim-bg.png"></div>
          <div class="front">
            <div class="anim anim-1" :class="{'active':currentIndex==0}">
              <div class="tips">
                <h4>产品介绍</h4>
                <p>丰富的贷款产品，充分享受随时随地申请的便利</p>
              </div>
              <img src="/static/img/wechat-anim-1.png">
            </div>
            <div class="anim anim-2" :class="{'active':currentIndex==1}">
              <div class="tips">
                <h4>我的订单</h4>
                <p>实时掌握您的借款动态</p>
              </div>
              <img src="/static/img/wechat-anim-2.png">
            </div>
            <div class="anim anim-3" :class="{'active':currentIndex==2}">
              <div class="tips">
                <h4>关于我们</h4>
                <p>一对一的专业客服在线帮助</p>
              </div>
              <img src="/static/img/wechat-anim-3.png">
            </div>
          </div>
        </div>
      </swiper-item>
    </swiper>
  </div>
</template>

<script>
  import Swiper from '@/components/swiper/swiper'
  import SwiperItem from '@/components/swiper/swiper-item'

  export default {
    name: 'Wechat',
    components: {
      Swiper,
      SwiperItem
    },
    data () {
      return {
        currentIndex: 0
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.$refs.wechatSwiper.init()
      })
    },
    created () {
      this.start()
    },
    beforeDestroy () {
      this.stop()
    },
    methods: {
      start () {
        this._timer = setInterval(() => {
          this.run()
        }, 5000 / 3)
      },
      run () {
        if (this.currentIndex >= 2) {
          this.currentIndex = 0
        } else {
          this.currentIndex = this.currentIndex + 1
        }
      },
      stop () {
        clearInterval(this._timer)
        this._timer = null
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .cover-wrapper
    background-position center
    background-size cover
  .anim-container
    position absolute
    width 1140px
    height 100%
    left 50%
    top 0
    margin-left -570px
    z-index 100
  .back, .front
    position absolute
    bottom -20px
    left 200px
    width 650px
    img
      max-width 100%
  .front
    height 175px
    .anim
      position absolute
      left 149px
      width 222px
      opacity 0
      filter 'alpha(opacity=0)'
      transition all .35s
      -ms-transition all .35s
      &.active
        opacity 1
        filter 'alpha(opacity=100)'
      .tips
        position absolute
        left 30px
        top -240%
        height 110px
        padding 20px
        color #fff
        font-size 18px
        line-height 24px
        background-color #2b9efc
        border-radius 7px
        transition all .35s
        -ms-transition all .35s
        transform translate(-50%, 0)
        -ms-transform translate(-50%, 0)
        &:after
          content ''
          position absolute
          width 40px
          height 40px
          left 50%
          bottom -15px
          z-index -1
          margin-left -20px
          border-radius 5px
          background-color #2b9efc
          transform rotate(45deg)
          -ms-transform rotate(45deg)
        h4
          margin 0
          font-size 24px
          font-weight normal
          transition all .35s
          -ms-transition all .35s
        p
          margin-top 10px
          margin-bottom 0
          white-space nowrap
      &.anim-2 .tips
        left 105px
      &.anim-3 .tips
        left 180px
  @media (min-width: 1400px)
    .back, .front
      left 80px
      bottom 0
      width 961px
    .front
      height 258px
      .anim
        left 221px
        width 400px
        .tips
          left 50px
          top -180%
          height 135px
          padding 30px
          font-size 22px
          line-height 36px
          h4
            font-size 28px
        &.anim-2 .tips
          left 150px
        &.anim-3 .tips
          left 260px
</style>



// WEBPACK FOOTER //
// wechat.vue?2d1b23ae